import {
  FETCH_CURRENT_AVE_MIN_MAX,
  CURRENT_AVE_MIN_MAX_FETCHED
} from '@/actions/ts/current'
import { createReducer } from '@/Util/ReduxUtils'

export const initialState = {
  currentAverageMinMax: {},
  currentAverageMinMaxError: null,
  isCurrentAveMinMaxLoading: false
}

const handlers = {
  [FETCH_CURRENT_AVE_MIN_MAX]: state => ({
    ...state,
    currentAverageMinMax: {},
    currentAverageMinMaxError: null,
    isCurrentAveMinMaxLoading: true
  }),
  [CURRENT_AVE_MIN_MAX_FETCHED]: (state, { error, currentAverageMinMax }) => ({
    ...state,
    currentAverageMinMax: error ? {} : currentAverageMinMax,
    currentAverageMinMaxError: error ?? null,
    isCurrentAveMinMaxLoading: false
  })
}

export default createReducer(handlers, initialState)
